import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { fetchApi } from '../../services/api';

type Props = RouteComponentProps<{
    childId: string
}>

type State = {
    isLoading: boolean;
}

export default class AttendancePrint extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            isLoading: true,
        }
    }

    public render() {
        return <div></div>
    }
}
